export const ErrorTypes = {
  htmlClientSessionContextFailed: 'html-client-session-context-failed',
  clientContextFailed: '{0}-failed', // use the same format sesssioncontext and authcontext
  clientSessionContextFailed: 'client-session-context-failed',
  clientSessionContextRetried: 'client-session-context-retried',
  metadataAdminCheckAccess: 'MetadataAdmin-CheckAccess',
  metadataAdminFetchTopicTree: 'MetadataAdmin-FetchTopicsTree',
  metadataAdminGetDownloadLink: 'MetadataAdmin-GetDownloadLink',
  metadataAdminRefresh: 'MetadataAdmin-RefreshData',
  metadataAdminUpdateData: 'MetadataAdmin-UpdateData',
  metadataAdminGetSelfHelp: 'MetadataAdmin-GetSelfHelp',
  authWorkspaceListFailed: 'authworkspace-connector-failed',
  serviceHealthAdminFailed: 'servicehealth-admin-failed',
  serviceHealthStatusFailed: 'servicehealth-status-failed',
  prefetchFailed: 'prefetch-failed',
};
